import {queryParamProps as footerQueryParamProps} from '../components/LFooter.vue';
import LList from '../components/LList.vue';

/**
 * The object below is the mapping object.
 * The key is the `from` query param name (in the browser URL) and the value is the `to` query param name (when calling the API).
 */
export const defaultParamMap = {
    [footerQueryParamProps.pageQueryParam.default]: 'page',
    [footerQueryParamProps.perPageQueryParam.default]: 'page[size]',
    [LList.props.sortQueryParam.default]: 'sort',
    [LList.props.textSearchQueryParam.default]: 'search',
};

/**
 * A conversion function to take the provided query object and convert it to a query param string when calling an API. Accepts a custom query parameter name object.
 *
 * @param Object queryObject
 * @param Object customParamMap
 * @returns String
 */
export function asString(queryObject, customParamMap = defaultParamMap) {
    let queryString = '';

    for (const param in queryObject) {
        if (Object.keys(customParamMap).includes(param)) {
            queryString += `&${customParamMap[param]}=${queryObject[param]}`;
        }
    }

    return queryString;
}
